import { httpClient } from './http-client';
import type {
  ChargeAmountResponseDto,
  ExternalHandoverLoginResponseDto,
  SendExternalHandoverLinkDto,
} from '@carvia/ros-client-types';

class ExternalHandoverService {
  endpoint = '/external-handover';

  async sendLink(data: SendExternalHandoverLinkDto) {
    await httpClient.post(`${this.endpoint}/send-link`, data);
  }

  async login(token: string) {
    const res = await httpClient.post<ExternalHandoverLoginResponseDto>(`${this.endpoint}/login`, {
      token,
    });
    return res.data;
  }

  async sendPaymentLink(bookingId: string) {
    const res = await httpClient.post<ChargeAmountResponseDto>(
      `${this.endpoint}/${bookingId}/payment-link`,
    );
    return res.data;
  }
}

export const externalHandoverService = new ExternalHandoverService();
